<div class="--card-grid p-8 gap-8">
  @for (item of links; track item) {
    <a
      class="--card"
      [href]="item.link"
      target="_blank"
      [id]="'card-' + item.rank + '-' + code"
      [attr.data-testid]="'card-' + item.rank">
      <div>
        <img [src]="getIcon(item)" [alt]="item.icon" class="--card-image" />
      </div>
      <h3 class="m-0 text-center">{{ getHeader(item) }}</h3>
      <div class="--card-text">{{ getText(item) }}</div>
    </a>
  }
</div>
